import LazyLoad from "vanilla-lazyload";

// Lazyload images
const lazyResources = new LazyLoad({ elements_selector: "img[data-src], video[data-src], iframe" });

export default lazyResources;
